import { render, staticRenderFns } from "./WeekText.vue?vue&type=template&id=96a0fb28"
import script from "./WeekText.vue?vue&type=script&lang=js"
export * from "./WeekText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports